import { ReportingPeriodViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { getReadablePayMonth } from '@fora-monorepo/employer-my-pages-common/utils';
import { ALL_OPTION, capitalizeString, OptionType } from '@foradevelopment/fora-ui';

import { typedT } from '../../i18n/i18n';

export const allMonthsOption: OptionType = {
  name: typedT('filter.selectorLabels.selectAllPeriods'),
  id: ALL_OPTION,
  bold: true,
  noMultiSelect: true,
};

// const LAST_MONTH = 'lastMonth',
//   LAST_THREE_MONTHS = 'last3Months',
//   LAST_SIX_MONTHS = 'last6Months',
//   LAST_YEAR = 'lastYear';

export const getMonthOptions = (payMonths: ReportingPeriodViewModel[]): OptionType[] => {
  const options: OptionType[] = [
    allMonthsOption,
    // Save options if needed in the future
    // { id: LAST_MONTH, name: t('filter.selectorLabels.lastMonth'), noMultiSelect: true },
    // { id: LAST_THREE_MONTHS, name: t('filter.selectorLabels.last3Months'), noMultiSelect: true },
    // { id: LAST_SIX_MONTHS, name: t('filter.selectorLabels.last6Months'), noMultiSelect: true },
    // { id: LAST_YEAR, name: t('filter.selectorLabels.lastYear'), noMultiSelect: true },
  ];

  payMonths
    .sort((a, b) => b.payMonth.localeCompare(a.payMonth))
    .forEach(x => {
      options.push({
        id: x.payMonth,
        name: capitalizeString(getReadablePayMonth(x.payMonth)),
      });
    });

  return options;
};
